// src/hooks/useNotificationSound.js
import { useCallback, useEffect, useRef } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Hook para reproducir sonidos de notificación en Web y Móvil (Capacitor)
 */
export const useNotificationSound = () => {
    const audioRef = useRef(null);
    const isNative = Capacitor.isNativePlatform();

    useEffect(() => {
        // En Web, precargar el audio
        if (!isNative) {
            audioRef.current = new Audio('/sounds/notification.mp3');
            audioRef.current.load();
        }
        // En Nativo, se podría usar @capacitor-community/native-audio si se requiere baja latencia
        // por ahora usaremos el fallback de Audio API que Capacitor soporta bien en primer plano.
    }, [isNative]);

    const playNotif = useCallback(() => {
        try {
            // Verificar si el audio está cargado o crearlo si no existe (fallback)
            const audio = audioRef.current || new Audio('/sounds/notification.mp3');

            // Reiniciar audio si ya se estaba reproduciendo
            audio.currentTime = 0;

            const playPromise = audio.play();

            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    // El navegador bloqueó el autoplay (común si el usuario no ha hecho clic)
                    console.warn('Audio play blocked or failed:', error);
                });
            }
        } catch (err) {
            console.error('Error playing notification sound:', err);
        }
    }, []);

    return { playNotif };
};
